/* eslint-disable max-lines */
import { defaultState } from '../../reducers/postCard/commentList';
import { ERequestStatus } from '../../types/requestStatus';
import { EStatus, ICommentParentSchema } from '../../repositories/journal/entities/comments/CommentParentSchema';
import { ICommentList, TCommentListState } from '../../types/commentList';

export const mkCommentListItems = (data?: ICommentParentSchema[]): ICommentParentSchema[] => {
  return [
    {
      userId: 18583573,
      status: EStatus.Checked,
      bestAdvice: false,
      id: 2024733,
      comments: [
        {
          userId: 13423037,
          status: EStatus.Checked,
          bestAdvice: false,
          id: 2024745,
          datePublish: '2024-09-13T16:12:44.356456+00:00',
          comment:
            'Она просто дорожает , потому что Гладиолус ,не один раз  были периоды обесценивания  рубля когда ставка аренды . падала , это тоже не причём . На счет спроса все очень токсично , единственный  фактор расширенного  спроса ( большего чем предыдущий период ) это беженцы из приграничных  регионов . Ну надо , чтоб росли , а цифры  роста должны быть в статистике в величину   абсолютой ( слово на ваш выбор ) ..',
          authorObject: {
            userIdentifications: true,
            linkUserProfiDescription: 'https://hc.cian.ru/hc/ru/articles/360049020211',
            companyName: null,
            isAgent: true,
            avatar: 'https://www.cian.ru/api/get-avatar/?i=54386393&t=2&p=2',
            userId: 18583573,
            email: null,
            linkUserProfile: null,
            userTrust: true,
            specialistLink: '/agents/18583573/',
            fullName: 'Дмитрий Редькин',
            isProfi: false,
            isEmailConfirmed: true,
            permissions: {
              canModerateAnnouncementsExpert: false,
              canModerateUsers: false,
              canHandleAnnouncements: false,
              canViewAnnouncements: false,
              canUseModerationComplaints: false,
              canModerateAnnouncements: false,
              canViewUsers: false,
              canViewHiddenAnnouncements: false,
            },
            linkUserTrustDescription: 'https://hc.cian.ru/hc/ru/articles/360061362792',
            locationIds: [1, 4593],
          },
          likesCount: 0,
          dislikesCount: 0,
        },
      ],
      datePublish: '2024-09-13T13:06:47.602095+00:00',
      comment:
        'Аренда дорожает от обесценивания рубля и баланса спроса(который зависит от ставки ипотеки на вторичку) и предложения (которое зависит от тревожности инфополя). Льготная ипотека тут не причем. Она на новострои, которые сдаются через 2-3 года.',
      authorObject: {
        userIdentifications: true,
        linkUserProfiDescription: 'https://hc.cian.ru/hc/ru/articles/360049020211',
        companyName: null,
        isAgent: true,
        avatar: 'https://www.cian.ru/api/get-avatar/?i=54386393&t=2&p=2',
        userId: 18583573,
        email: null,
        linkUserProfile: null,
        userTrust: true,
        specialistLink: '/agents/18583573/',
        fullName: 'Дмитрий Редькин',
        isProfi: false,
        isEmailConfirmed: true,
        permissions: {
          canModerateAnnouncementsExpert: false,
          canModerateUsers: false,
          canHandleAnnouncements: false,
          canViewAnnouncements: false,
          canUseModerationComplaints: false,
          canModerateAnnouncements: false,
          canViewUsers: false,
          canViewHiddenAnnouncements: false,
        },
        linkUserTrustDescription: 'https://hc.cian.ru/hc/ru/articles/360061362792',
        locationIds: [1, 4593],
      },
      likesCount: 0,
      dislikesCount: 0,
    },
    {
      userId: 121471807,
      status: EStatus.Unchecked,
      bestAdvice: false,
      id: 2024598,
      comments: null,
      datePublish: '2024-09-06T15:21:30.089809+00:00',
      comment: 'А я в ближнем Подмосковье в вагончике живу и доволен...',
      authorObject: {
        userIdentifications: true,
        linkUserProfiDescription: 'https://hc.cian.ru/hc/ru/articles/360049020211',
        companyName: null,
        isAgent: false,
        avatar: 'https://www.cian.ru/avatar.axd?i=121471807&t=1&p=2',
        userId: 121471807,
        email: null,
        linkUserProfile: null,
        userTrust: false,
        specialistLink: null,
        fullName: '',
        isProfi: false,
        isEmailConfirmed: false,
        permissions: {
          canModerateAnnouncementsExpert: false,
          canModerateUsers: false,
          canHandleAnnouncements: false,
          canViewAnnouncements: false,
          canUseModerationComplaints: false,
          canModerateAnnouncements: false,
          canViewUsers: false,
          canViewHiddenAnnouncements: false,
        },
        linkUserTrustDescription: 'https://hc.cian.ru/hc/ru/articles/360061362792',
        locationIds: [],
      },
      likesCount: 0,
      dislikesCount: 0,
    },
    {
      userId: 121160771,
      status: EStatus.Unchecked,
      bestAdvice: false,
      id: 2024490,
      comments: null,
      datePublish: '2024-08-31T07:45:57.791456+00:00',
      comment:
        'Снимаю квартиру в ближнем Подмосковье с 2015 года и ощущаю все прелести рынка аренды жилья. И мне абсолютно не понятна логика движения цен. Почему, когда была дармовая ипотека 2017-2020, которая вызвала бурный рост цен на недвижимость, вслед за этим вверх потянулась аренда на 50-60% . Ведь по логике, указанной в публикации, должно было быть наоборот. Сейчас же на рынке ситуация абсолютно противоположная, но аренда  опять поднялась.',
      authorObject: {
        userIdentifications: true,
        linkUserProfiDescription: 'https://hc.cian.ru/hc/ru/articles/360049020211',
        companyName: null,
        isAgent: false,
        avatar: 'https://www.cian.ru/avatar.axd?i=121160771&t=1&p=2',
        userId: 121160771,
        email: null,
        linkUserProfile: null,
        userTrust: false,
        specialistLink: null,
        fullName: '',
        isProfi: false,
        isEmailConfirmed: false,
        permissions: {
          canModerateAnnouncementsExpert: false,
          canModerateUsers: false,
          canHandleAnnouncements: false,
          canViewAnnouncements: false,
          canUseModerationComplaints: false,
          canModerateAnnouncements: false,
          canViewUsers: false,
          canViewHiddenAnnouncements: false,
        },
        linkUserTrustDescription: 'https://hc.cian.ru/hc/ru/articles/360061362792',
        locationIds: [],
      },
      likesCount: 0,
      dislikesCount: 0,
    },
    {
      userId: 13423037,
      status: EStatus.Unchecked,
      bestAdvice: false,
      id: 2024313,
      comments: null,
      datePublish: '2024-08-22T16:36:17.967793+00:00',
      comment:
        'Слово Кошмар будет на рынке недвижимости  , но для кого это решит время и фундаментальные факторы , а так кто кого будет кошмарить  видно по динамике ставки за десять лет  , котороя околонулевая  , а стиралка  в цене  подорожало в два раза , забудьте  нулевые и очереди  на квартиры с разбитыми унитазами ..',
      authorObject: {
        userIdentifications: true,
        linkUserProfiDescription: 'https://hc.cian.ru/hc/ru/articles/360049020211',
        companyName: null,
        isAgent: false,
        avatar: 'https://www.cian.ru/avatar.axd?i=13423037&t=1&p=2',
        userId: 13423037,
        email: null,
        linkUserProfile: null,
        userTrust: false,
        specialistLink: null,
        fullName: 'Сергей ТСТ',
        isProfi: false,
        isEmailConfirmed: true,
        permissions: {
          canModerateAnnouncementsExpert: false,
          canModerateUsers: false,
          canHandleAnnouncements: false,
          canViewAnnouncements: false,
          canUseModerationComplaints: false,
          canModerateAnnouncements: false,
          canViewUsers: false,
          canViewHiddenAnnouncements: false,
        },
        linkUserTrustDescription: 'https://hc.cian.ru/hc/ru/articles/360061362792',
        locationIds: [1],
      },
      likesCount: 0,
      dislikesCount: 0,
    },
    {
      userId: 13423037,
      status: EStatus.Unchecked,
      bestAdvice: false,
      id: 2024203,
      comments: null,
      datePublish: '2024-08-19T23:59:23.457136+00:00',
      comment:
        'Пиар компания  по напугиванию  арендаторов преследует  лишь цель напугать  и загнать  людей из аренды в ипотеку , ну и безусловно  оправдаться  перед теми  кто купил по формуле купи -сдай   , реальные ценник  -ставка аренды оказалась  критически  ниже  обещенных..<br />Рынок аренды имеет  свою экономику  , она ни как не привязана  с ипотечными процетами , <br />Рынок аренды привязан к рынку труда , емкости рабочих мест и разницы оплаты  между регионом притока и оттока .. Все  сдерживающие факторы  работали и сдерживали рост .. <br />Сегодня  ( после оттока мигрантов -иногородних в  2020 году) рекордный ввод  жилья , открытие рабочих мест в регионах и рост зарплат , все говорит  о  спаде  реального спроса и рост предложения ..<br />Тема  эвакуированых с приграничья  ровным счетом сойдет на нет  через месяц два , при любом  развитие ситуации ..',
      authorObject: {
        userIdentifications: true,
        linkUserProfiDescription: 'https://hc.cian.ru/hc/ru/articles/360049020211',
        companyName: null,
        isAgent: false,
        avatar: 'https://www.cian.ru/avatar.axd?i=13423037&t=1&p=2',
        userId: 13423037,
        email: null,
        linkUserProfile: null,
        userTrust: false,
        specialistLink: null,
        fullName: 'Сергей ТСТ',
        isProfi: false,
        isEmailConfirmed: true,
        permissions: {
          canModerateAnnouncementsExpert: false,
          canModerateUsers: false,
          canHandleAnnouncements: false,
          canViewAnnouncements: false,
          canUseModerationComplaints: false,
          canModerateAnnouncements: false,
          canViewUsers: false,
          canViewHiddenAnnouncements: false,
        },
        linkUserTrustDescription: 'https://hc.cian.ru/hc/ru/articles/360061362792',
        locationIds: [1],
      },
      likesCount: 0,
      dislikesCount: 0,
    },
    {
      userId: 117408823,
      status: EStatus.Unchecked,
      bestAdvice: false,
      id: 2024187,
      comments: [
        {
          userId: 13423037,
          status: EStatus.Unchecked,
          bestAdvice: false,
          id: 2024204,
          datePublish: '2024-08-20T00:03:20.393618+00:00',
          comment:
            'Математика точная наука , в буквах можно  сменить  аренду на ипотеку , в цифрах нет .. цифры в студию ))) ипотека на готовое жилье   (вторичка ) покупай-заезжай 20 % )))<br />80% иногородних -мигрантов  получают  зарплату  до 80 тысяч , просьба  много не писать , особенно те кто не смог купить при атракционне низких ставок  вплоть  до нулевых и того меньше зарабатывают ..',
          authorObject: {
            userIdentifications: true,
            linkUserProfiDescription: 'https://hc.cian.ru/hc/ru/articles/360049020211',
            companyName: null,
            isAgent: false,
            avatar: 'https://www.cian.ru/avatar.axd?i=117408823&t=1&p=2',
            userId: 117408823,
            email: null,
            linkUserProfile: null,
            userTrust: false,
            specialistLink: null,
            fullName: 'Олеся',
            isProfi: false,
            isEmailConfirmed: false,
            permissions: {
              canModerateAnnouncementsExpert: false,
              canModerateUsers: false,
              canHandleAnnouncements: false,
              canViewAnnouncements: false,
              canUseModerationComplaints: false,
              canModerateAnnouncements: false,
              canViewUsers: false,
              canViewHiddenAnnouncements: false,
            },
            linkUserTrustDescription: 'https://hc.cian.ru/hc/ru/articles/360061362792',
            locationIds: [],
          },
          likesCount: 0,
          dislikesCount: 0,
        },
        {
          userId: 90849865,
          status: EStatus.Unchecked,
          bestAdvice: false,
          id: 2024306,
          datePublish: '2024-08-22T14:29:56.497690+00:00',
          comment: 'Вы считаете 5 тыс это дорого????? Или люди в убыток себе сдавать будут?',
          authorObject: {
            userIdentifications: true,
            linkUserProfiDescription: 'https://hc.cian.ru/hc/ru/articles/360049020211',
            companyName: null,
            isAgent: false,
            avatar: 'https://www.cian.ru/avatar.axd?i=117408823&t=1&p=2',
            userId: 117408823,
            email: null,
            linkUserProfile: null,
            userTrust: false,
            specialistLink: null,
            fullName: 'Олеся',
            isProfi: false,
            isEmailConfirmed: false,
            permissions: {
              canModerateAnnouncementsExpert: false,
              canModerateUsers: false,
              canHandleAnnouncements: false,
              canViewAnnouncements: false,
              canUseModerationComplaints: false,
              canModerateAnnouncements: false,
              canViewUsers: false,
              canViewHiddenAnnouncements: false,
            },
            linkUserTrustDescription: 'https://hc.cian.ru/hc/ru/articles/360061362792',
            locationIds: [],
          },
          likesCount: 0,
          dislikesCount: 0,
        },
        {
          userId: 13423037,
          status: EStatus.Unchecked,
          bestAdvice: false,
          id: 2024312,
          datePublish: '2024-08-22T16:33:39.013069+00:00',
          comment:
            'Люди будут сдавать , ровно за сколько   за сколько заплатят , надо будет  за коммуналку будут сдавать и пыль вытерать , арендодатель  не боярен , а арендатор не крепостной ..',
          authorObject: {
            userIdentifications: true,
            linkUserProfiDescription: 'https://hc.cian.ru/hc/ru/articles/360049020211',
            companyName: null,
            isAgent: false,
            avatar: 'https://www.cian.ru/avatar.axd?i=117408823&t=1&p=2',
            userId: 117408823,
            email: null,
            linkUserProfile: null,
            userTrust: false,
            specialistLink: null,
            fullName: 'Олеся',
            isProfi: false,
            isEmailConfirmed: false,
            permissions: {
              canModerateAnnouncementsExpert: false,
              canModerateUsers: false,
              canHandleAnnouncements: false,
              canViewAnnouncements: false,
              canUseModerationComplaints: false,
              canModerateAnnouncements: false,
              canViewUsers: false,
              canViewHiddenAnnouncements: false,
            },
            linkUserTrustDescription: 'https://hc.cian.ru/hc/ru/articles/360061362792',
            locationIds: [],
          },
          likesCount: 0,
          dislikesCount: 0,
        },
      ],
      datePublish: '2024-08-19T17:11:40.706332+00:00',
      comment:
        'Мне сегодня подняли сразу на 5 тысяч оплату 😀4 года снимаю, каждый год поднимали на 2 тысячи.Теперь на 5 .Еще и увеличить залог хочет.Ну принимаем данность и ищем пути приобрести свое жилье наконец-то)',
      authorObject: {
        userIdentifications: true,
        linkUserProfiDescription: 'https://hc.cian.ru/hc/ru/articles/360049020211',
        companyName: null,
        isAgent: false,
        avatar: 'https://www.cian.ru/avatar.axd?i=117408823&t=1&p=2',
        userId: 117408823,
        email: null,
        linkUserProfile: null,
        userTrust: false,
        specialistLink: null,
        fullName: 'Олеся',
        isProfi: false,
        isEmailConfirmed: false,
        permissions: {
          canModerateAnnouncementsExpert: false,
          canModerateUsers: false,
          canHandleAnnouncements: false,
          canViewAnnouncements: false,
          canUseModerationComplaints: false,
          canModerateAnnouncements: false,
          canViewUsers: false,
          canViewHiddenAnnouncements: false,
        },
        linkUserTrustDescription: 'https://hc.cian.ru/hc/ru/articles/360061362792',
        locationIds: [],
      },
      likesCount: 0,
      dislikesCount: 0,
    },
    {
      userId: 119553586,
      status: EStatus.Unchecked,
      bestAdvice: false,
      id: 2024159,
      comments: null,
      datePublish: '2024-08-18T18:59:27.754492+00:00',
      comment:
        'В Москве сами агентства по аренде недвижимости способствуют росту цен на аренду. Когда всеми правдами и неправдами перехватывают жилье у собственников, которые выкладывают свое жилье по адекватной цене, агенты задалбывают их своими звонками с обещаниями сдать их жилье гораздо дороже. Именно это я наблюдаю на ЦИАН. И это печально. Рост цен на аренду абсолютно искусственный, продиктованный только желанием агентств заработать. А в итоге пострадают те же собственники, так как эти непомерные суммы не смогут потом платить арендаторы.',
      authorObject: {
        userIdentifications: true,
        linkUserProfiDescription: 'https://hc.cian.ru/hc/ru/articles/360049020211',
        companyName: null,
        isAgent: false,
        avatar: 'https://www.cian.ru/avatar.axd?i=119553586&t=1&p=2',
        userId: 119553586,
        email: null,
        linkUserProfile: null,
        userTrust: false,
        specialistLink: null,
        fullName: '',
        isProfi: false,
        isEmailConfirmed: false,
        permissions: {
          canModerateAnnouncementsExpert: false,
          canModerateUsers: false,
          canHandleAnnouncements: false,
          canViewAnnouncements: false,
          canUseModerationComplaints: false,
          canModerateAnnouncements: false,
          canViewUsers: false,
          canViewHiddenAnnouncements: false,
        },
        linkUserTrustDescription: 'https://hc.cian.ru/hc/ru/articles/360061362792',
        locationIds: [],
      },
      likesCount: 0,
      dislikesCount: 0,
    },
    {
      userId: 95189348,
      status: EStatus.Unchecked,
      bestAdvice: false,
      id: 2023632,
      comments: [
        {
          userId: 86666226,
          status: EStatus.Unchecked,
          bestAdvice: false,
          id: 2024545,
          datePublish: '2024-09-04T12:32:54.244117+00:00',
          comment:
            'Все из-за ситуации на юге, сами понимаете все прекрасно, на что нужны деньги. <br />Ситуация оооочень сложная, за бабушатники с ремонтом с времен советов пытаются сдать за 40-50к <br />Иногда вижу квартиры захламленные, люди просто офигели, сдают квартиры с всем барахлом, риэлтор Вы куда смотрите, я бы в работу такие квартиры не брал бы даже, пока хотя бы не уберутся элементарно....это пи...!',
          authorObject: {
            userIdentifications: true,
            linkUserProfiDescription: 'https://hc.cian.ru/hc/ru/articles/360049020211',
            companyName: null,
            isAgent: false,
            avatar: 'https://www.cian.ru/avatar.axd?i=95189348&t=1&p=2',
            userId: 95189348,
            email: null,
            linkUserProfile: null,
            userTrust: false,
            specialistLink: null,
            fullName: 'Коля',
            isProfi: false,
            isEmailConfirmed: false,
            permissions: {
              canModerateAnnouncementsExpert: false,
              canModerateUsers: false,
              canHandleAnnouncements: false,
              canViewAnnouncements: false,
              canUseModerationComplaints: false,
              canModerateAnnouncements: false,
              canViewUsers: false,
              canViewHiddenAnnouncements: false,
            },
            linkUserTrustDescription: 'https://hc.cian.ru/hc/ru/articles/360061362792',
            locationIds: [],
          },
          likesCount: 0,
          dislikesCount: 0,
        },
      ],
      datePublish: '2024-08-02T16:58:06.528374+00:00',
      comment:
        'Не понимаю чего правительство само себе же палки в колеса ставит, если могут сейчас на этом этапе взять всю недвиьку под свой контроль.Стопорнуть полностью рост цен, снизить арендную плату и ипотеку до минимума.Надутый пузырь алчных застройщиков по вине которых сейчас сложилась такая ситуация в стране.И самое главное собственники квартир ах*ели сами тоже.В задрипанной квартире на окраине поселка просят 40-50к.Как вы считаете это вообще адекватно,а?',
      authorObject: {
        userIdentifications: true,
        linkUserProfiDescription: 'https://hc.cian.ru/hc/ru/articles/360049020211',
        companyName: null,
        isAgent: false,
        avatar: 'https://www.cian.ru/avatar.axd?i=95189348&t=1&p=2',
        userId: 95189348,
        email: null,
        linkUserProfile: null,
        userTrust: false,
        specialistLink: null,
        fullName: 'Коля',
        isProfi: false,
        isEmailConfirmed: false,
        permissions: {
          canModerateAnnouncementsExpert: false,
          canModerateUsers: false,
          canHandleAnnouncements: false,
          canViewAnnouncements: false,
          canUseModerationComplaints: false,
          canModerateAnnouncements: false,
          canViewUsers: false,
          canViewHiddenAnnouncements: false,
        },
        linkUserTrustDescription: 'https://hc.cian.ru/hc/ru/articles/360061362792',
        locationIds: [],
      },
      likesCount: 0,
      dislikesCount: 0,
    },
    {
      userId: 98381864,
      status: EStatus.Unchecked,
      bestAdvice: false,
      id: 2023567,
      comments: [
        {
          userId: 95189348,
          status: EStatus.Unchecked,
          bestAdvice: false,
          id: 2023633,
          datePublish: '2024-08-02T16:59:13.841448+00:00',
          comment: 'ой наверное комментарий собственника))))',
          authorObject: {
            userIdentifications: true,
            linkUserProfiDescription: 'https://hc.cian.ru/hc/ru/articles/360049020211',
            companyName: null,
            isAgent: false,
            avatar: 'https://www.cian.ru/avatar.axd?i=98381864&t=1&p=2',
            userId: 98381864,
            email: null,
            linkUserProfile: null,
            userTrust: false,
            specialistLink: null,
            fullName: 'Чарльз Понцы',
            isProfi: false,
            isEmailConfirmed: false,
            permissions: {
              canModerateAnnouncementsExpert: false,
              canModerateUsers: false,
              canHandleAnnouncements: false,
              canViewAnnouncements: false,
              canUseModerationComplaints: false,
              canModerateAnnouncements: false,
              canViewUsers: false,
              canViewHiddenAnnouncements: false,
            },
            linkUserTrustDescription: 'https://hc.cian.ru/hc/ru/articles/360061362792',
            locationIds: [],
          },
          likesCount: 0,
          dislikesCount: 0,
        },
      ],
      datePublish: '2024-08-01T12:05:37.498350+00:00',
      comment:
        'Господи, какой ужас я только что прочитал! а ведь кто-то это примет за чистую монету!<br />Автор утверждает, что арнеда не росла, потому что льготная ипотека позволяла купить "своё" жилье, а не платить ДОРОГУЮ аренду? Хахаха, а при льготной ипотеке каждый месяц платить банку не надо? в течение 30 лет (у многих!) Когда человеку ПРОЩЕ взять ипотеку нежели платить арнеду это значит, что экономическая модель настолько извращена, что НЕИЗБЕЖНО последует что-то катастрофическое. Автор упоминает кризис 2008 года в Америке. Громнуло там так, что у нас в России все обвалилось, хотя где мы и где Америка. Накопленные перекосы в рынке недвижимости России НАСТОЛЬКО чудовищны, что скоро "дорогая аренда", про которую тут поет Автор, покажется детским лепетом....',
      authorObject: {
        userIdentifications: true,
        linkUserProfiDescription: 'https://hc.cian.ru/hc/ru/articles/360049020211',
        companyName: null,
        isAgent: false,
        avatar: 'https://www.cian.ru/avatar.axd?i=98381864&t=1&p=2',
        userId: 98381864,
        email: null,
        linkUserProfile: null,
        userTrust: false,
        specialistLink: null,
        fullName: 'Чарльз Понцы',
        isProfi: false,
        isEmailConfirmed: false,
        permissions: {
          canModerateAnnouncementsExpert: false,
          canModerateUsers: false,
          canHandleAnnouncements: false,
          canViewAnnouncements: false,
          canUseModerationComplaints: false,
          canModerateAnnouncements: false,
          canViewUsers: false,
          canViewHiddenAnnouncements: false,
        },
        linkUserTrustDescription: 'https://hc.cian.ru/hc/ru/articles/360061362792',
        locationIds: [],
      },
      likesCount: 0,
      dislikesCount: 0,
    },
    {
      userId: 114501003,
      status: EStatus.Unchecked,
      bestAdvice: false,
      id: 2023561,
      comments: null,
      datePublish: '2024-08-01T11:31:28.084272+00:00',
      comment:
        'Рост аренды сдерживается отсутствием роста заработной платы. Жилье к тому же начнет дешеветь при такой ипотеке, что сделает его более доступным и без кредитов.',
      authorObject: {
        userIdentifications: true,
        linkUserProfiDescription: 'https://hc.cian.ru/hc/ru/articles/360049020211',
        companyName: null,
        isAgent: false,
        avatar: 'https://www.cian.ru/avatar.axd?i=114501003&t=1&p=2',
        userId: 114501003,
        email: null,
        linkUserProfile: null,
        userTrust: false,
        specialistLink: null,
        fullName: '',
        isProfi: false,
        isEmailConfirmed: false,
        permissions: {
          canModerateAnnouncementsExpert: false,
          canModerateUsers: false,
          canHandleAnnouncements: false,
          canViewAnnouncements: false,
          canUseModerationComplaints: false,
          canModerateAnnouncements: false,
          canViewUsers: false,
          canViewHiddenAnnouncements: false,
        },
        linkUserTrustDescription: 'https://hc.cian.ru/hc/ru/articles/360061362792',
        locationIds: [],
      },
      likesCount: 0,
      dislikesCount: 0,
    },
    {
      userId: 58159471,
      status: EStatus.Unchecked,
      bestAdvice: false,
      id: 2023450,
      comments: [
        {
          userId: 98786115,
          status: EStatus.Unchecked,
          bestAdvice: false,
          id: 2023638,
          datePublish: '2024-08-02T18:15:51.972121+00:00',
          comment: 'Уже',
          authorObject: {
            userIdentifications: true,
            linkUserProfiDescription: 'https://hc.cian.ru/hc/ru/articles/360049020211',
            companyName: null,
            isAgent: false,
            avatar: 'https://www.cian.ru/avatar.axd?i=58159471&t=1&p=2',
            userId: 58159471,
            email: null,
            linkUserProfile: null,
            userTrust: false,
            specialistLink: null,
            fullName: 'Vladimir Tsekhovoi',
            isProfi: false,
            isEmailConfirmed: true,
            permissions: {
              canModerateAnnouncementsExpert: false,
              canModerateUsers: false,
              canHandleAnnouncements: false,
              canViewAnnouncements: false,
              canUseModerationComplaints: false,
              canModerateAnnouncements: false,
              canViewUsers: false,
              canViewHiddenAnnouncements: false,
            },
            linkUserTrustDescription: 'https://hc.cian.ru/hc/ru/articles/360061362792',
            locationIds: [],
          },
          likesCount: 0,
          dislikesCount: 0,
        },
      ],
      datePublish: '2024-07-29T22:24:18.676366+00:00',
      comment: 'все логично и взвешено в этой статье, аренда будет дорожать',
      authorObject: {
        userIdentifications: true,
        linkUserProfiDescription: 'https://hc.cian.ru/hc/ru/articles/360049020211',
        companyName: null,
        isAgent: false,
        avatar: 'https://www.cian.ru/avatar.axd?i=58159471&t=1&p=2',
        userId: 58159471,
        email: null,
        linkUserProfile: null,
        userTrust: false,
        specialistLink: null,
        fullName: 'Vladimir Tsekhovoi',
        isProfi: false,
        isEmailConfirmed: true,
        permissions: {
          canModerateAnnouncementsExpert: false,
          canModerateUsers: false,
          canHandleAnnouncements: false,
          canViewAnnouncements: false,
          canUseModerationComplaints: false,
          canModerateAnnouncements: false,
          canViewUsers: false,
          canViewHiddenAnnouncements: false,
        },
        linkUserTrustDescription: 'https://hc.cian.ru/hc/ru/articles/360061362792',
        locationIds: [],
      },
      likesCount: 0,
      dislikesCount: 0,
    },
    ...(data || []),
  ];
};

export const mkCommentList = (data?: ICommentList): ICommentList => {
  return {
    meta: {
      ...defaultState.meta,
      total: 11,
    },
    items: mkCommentListItems(),
    ...data,
  };
};

export const mkCommentListState = (data?: Partial<TCommentListState>): TCommentListState => {
  return {
    ...defaultState,
    ...mkCommentList(),
    status: ERequestStatus.Succeed,
    ...data,
  };
};
